// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kxeC","icon":"styles_icon__2su_l"};